// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLock = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11 13v4h2v-4z" />,
    <path fillRule="evenodd" d="M7 6v3H4v12h16V9h-3V6A5 5 0 007 6m5-3a3 3 0 00-3 3v3h6V6a3 3 0 00-3-3m-6 8v8h12v-8z" />
  );
export default SvgIconLock;
